import { render, staticRenderFns } from "./Select.vue?vue&type=template&id=8755d2ac&scoped=true"
import script from "./Select.vue?vue&type=script&lang=ts&setup=true"
export * from "./Select.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8755d2ac",
  null
  
)

export default component.exports